import useSWR from 'swr'

const fetcher = (url: string) =>
  fetch(url, {
    credentials: 'include',
    headers: [['Cache-Control', 'no-cache']],
  }).then((res) => {
    if (!res.ok) {
      return res.text().then((text) => {
        throw new Error(`GET failed: ${res.status} ${text}`)
      })
    }
    return res.json()
  })

/**
 * Lists submissions for an equity record. Backend: GET .../equity/{id}/submissions
 * (mounted under /api/v2/admin in this app — adjust if your gateway uses another prefix).
 */
const useEquitySubmissions = (equityId: string | undefined) => {
  const base = process.env.REACT_APP_BACKEND_URL
  const key =
    equityId && base
      ? `${base}/api/v2/admin/deals/equity/${encodeURIComponent(
          equityId,
        )}/submissions`
      : null

  const { data, error, isLoading, mutate } = useSWR(key, fetcher)

  const payload = data?.data ?? data
  const submissions = Array.isArray(payload) ? payload : []

  return {
    submissions,
    raw: data,
    isLoading,
    isError: error,
    mutate,
  }
}

export default useEquitySubmissions
